function animateRollingCounters(className = "rolling-counter", staggerDelay = 100) {
  const counters = document.querySelectorAll(`.${className}`);
  const chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz., ";

  counters.forEach((counter) => {
    const target = counter.getAttribute("data-target") || "";
    const suffix = counter.getAttribute("data-suffix") || "";
    const fullText = `${target}${suffix}`;

    counter.innerHTML = ""; // Clear existing content

    let maxAnimationTime = 0;

    [...fullText].forEach((char, i) => {
      const column = document.createElement("span");
      column.className = "roller-digit";

      const sequence = document.createElement("div");
      sequence.className = "roller-sequence";

      let sequenceHTML = "";
      for (let j = 0; j < 10; j++) {
        const randChar = chars[Math.floor(Math.random() * chars.length)];
        sequenceHTML += `<div>${randChar}</div>`;
      }

      sequenceHTML += `<div>${char}</div>`; // Final character
      sequence.innerHTML = sequenceHTML;

      const delay = i * staggerDelay;
      const duration = 600;

      sequence.style.animationDelay = `${delay}ms`;
      sequence.style.animationDuration = `${duration}ms`;
      sequence.style.animationFillMode = "forwards";

      column.appendChild(sequence);
      counter.appendChild(column);

      const animationEnd = delay + duration;
      if (animationEnd > maxAnimationTime) {
        maxAnimationTime = animationEnd;
      }
    });

    // After all animations complete, replace with full static text
    setTimeout(() => {
      counter.innerHTML = fullText;
    }, maxAnimationTime + 10); // Add a small buffer
  });
}



  let countersAnimated = false; // Make sure it only runs once

  function isScrollPastThreshold(thresholdRatio = 0.5) {
    return window.scrollY > window.innerHeight * thresholdRatio;
  }

  function onScrollTriggerCounter() {
    if (!countersAnimated && isScrollPastThreshold(0.5)) {
      animateRollingCounters();  // Call your function
      countersAnimated = true;   // Prevent future calls
      window.removeEventListener('scroll', onScrollTriggerCounter); // Optional cleanup
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    window.addEventListener('scroll', onScrollTriggerCounter);
  });